module.exports = __webpack_public_path__ + "img/venuetwo-jkzsdt-title.f6e1c69f.png";